import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DocumentFormat, DocumentPermission, DocumentSummaryModel} from '../../model/documentSummary.model';
import {
  ReportComponentPreviewPayload
} from '../../../../../reporting/report-component/impl/service/paylaod/reportComponentPreview.payload';
import {PayloadWithId} from '../../../../../core/service/payload/payloadWithId';
import {DownloadButtonComponent} from '../../../../../core/component/download-button/download-button.component';
import {DocumentDownloadService} from '../../service/documentDownload.service';

@Component({
  selector: 'app-document-download',
  templateUrl: './document-download.component.html',
  viewProviders: [
    DocumentDownloadService
  ]
})
export class DocumentDownloadComponent implements OnInit, OnChanges {
  @Input() documentId: number;
  @Input() fileName: string;
  @Input() label: string;
  @Input() entity: DocumentSummaryModel;
  @Input() fill = 'clear';
  @Input() downloadOnRefresh = false;
  @Input() downloadOnInit = false;
  @Input() withMargin = true;
  @Input() withPadding = true;
  @Input() tooltip = 'Télécharger';
  @Input() color = 'accent';
  @Output() downloadStartedEvent: EventEmitter<Blob> = new EventEmitter();
  @ViewChild('button') button: DownloadButtonComponent<any>;


  DOCUMENT_PERMISSION_DOWNLOAD = DocumentPermission.DOCUMENT_PERMISSION_DOWNLOAD;
  pdfPreview = false;
  imagePreview = false;
  iconName = 'download';


  constructor(public service: DocumentDownloadService) {

  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    const entityChanges = changes['entity'];
    if (entityChanges) {
      this.pdfPreview = this.entity?.format?.value === DocumentFormat.PDF;
      this.imagePreview = this.entity?.format?.value === DocumentFormat.IMAGE;
      this.iconName = (this.pdfPreview || this.imagePreview) ? 'eye' : 'download';
      // console.log(['DocumentDownloadComponent', this.pdfPreview, this.entity]);
    }

  }

  // FIXME Maxime ReportComponentPreviewPayload has nothing to do here
  buildPayload = (): PayloadWithId => {
    const payload = new ReportComponentPreviewPayload();
    payload.id = this.entity ? this.entity.id : this.documentId;
    return payload;
  }

  execute() {
    this.button?.executeDownload();
  }

  executeWithPayload(payload: PayloadWithId) {
    this.button?.executeDownloadWithPayload(payload);
  }


}
